import { jsx as d } from "react/jsx-runtime";
import { createRoot as s } from "react-dom/client";
import { a, P as c } from "./portal-scope-C4IEbiQl.mjs";
const l = "dialog-container", A = (e) => {
  const o = e.id || m(e.title || "") || "dialog";
  if (typeof document > "u") return { destroy: () => {
  } };
  if (document.querySelector(`.${l}.${o}`))
    return { destroy: () => {
    } };
  const n = e.id || `dialog_${Date.now()}`, t = u(o, n), r = s(t);
  return r.render(/* @__PURE__ */ d(a, { ...e, show: !0 })), {
    destroy: () => {
      r.render(
        /* @__PURE__ */ d(
          a,
          {
            ...e,
            onAnimationEnd: () => {
              var i;
              r.unmount(), (i = t.parentElement) == null || i.removeChild(t);
            },
            show: !1
          }
        )
      );
    }
  };
};
function u(e, o) {
  const n = document.querySelector("body"), t = document.createElement("div");
  return t.className = `${l} ${e} ${o}`, n.appendChild(t);
}
function m(e) {
  try {
    return `nol_${e.split("").reduce((o, n) => {
      const t = (o << 5) - o + n.charCodeAt(0);
      return t & t;
    }, 0).toString()}`;
  } catch {
    return "";
  }
}
const g = "pc-dialog-sheet-container", C = (e) => {
  if (typeof document > "u") return { destroy: () => {
  } };
  const o = e.id || `dialog_${Date.now()}`, n = y(o), t = s(n);
  return t.render(/* @__PURE__ */ d(c, { ...e, show: !0 })), {
    destroy: () => {
      t.render(
        /* @__PURE__ */ d(
          c,
          {
            ...e,
            onAnimationEnd: () => {
              var r;
              t.unmount(), (r = n.parentElement) == null || r.removeChild(n);
            },
            show: !1
          }
        )
      );
    }
  };
};
function y(e) {
  const o = document.querySelector("body"), n = document.createElement("div");
  return n.className = `${g} ${e}`, o.appendChild(n);
}
export {
  C as a,
  A as s
};
